import { cn } from "@/lib/utils"

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "animate-pulse rounded-xl bg-background-secondary/50 dark:bg-background-dark-secondary/50 border border-border dark:border-border-dark backdrop-blur-xl backdrop-saturate-150",
        className
      )}
      {...props}
    />
  )
}

export { Skeleton } 